/* eslint-disable no-console */
import { cloneDeep } from 'lodash';
import fileSaver from 'file-saver';
import moment from 'moment';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import t from './DevelopmentOrder.type';
import * as DevelopmentOrder from '../../../services/developmentOrder.service';
import * as Prodtesting from '../../../services/product-testing';
import * as ProductDesigns from '../../../services/product-designs';
import { runBackgroundUpload } from '../../../services/background-upload';
import uploaderType from '../../UploaderRedux/store/uploader.type';
import { getSlugName, formatFileSize } from '../../../Components/helper';
import { generateUniqueFilePrefix } from '../DesignDetail/utils/helpers';
import * as Sample from '../../../services/sample.service';
import * as SystemMasterServices from '../../../services/SystemMaster.services';
import * as SupplierSuggestionService from '../../../services/supplierSuggestion.service';
import { ERROR_MESSAGE, getApiErrorKey, backendErrorMsg } from '../../../Components/helper';
import { getAvailableModulesForDevOrder } from '../../../services/custom-module.services';
import { listControlLibrariesForProduct } from '../../../services/control-library.services';
import i18next from 'i18next';
import { HTTP_STATUS } from '../../../constants/api-status-codes';
import { withoutClientKeys } from '../Measurment/specSavePayload';
import { isLiveInAnotherTab } from '../../../utils/upload-tab-coordinator';

const BASE_SIZE_MISMATCH_TOAST_DURATION = 8000;
const BASE_SIZE_MISMATCH_MESSAGE_KEY = 'product-sample:DEVELOPMENT_ORDER.SAMPLE_BASE_SIZE_MISMATCH_NOT_SYNCED';

export const getMeasurmentDetails = (params, orderType) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getSelectedGradGroupData(params);
    if (orderType === 'spec-pom') {
      await dispatch({
        type: t.GET_ORDER_MEASUREMENTS,
        payload: res.data.specPomLibraries,
      });
    }

    if (orderType === 'cad-pom') {
      await dispatch({
        type: t.GET_ORDER_MEASUREMENTS,
        payload: res.data.pomLibraries,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setMeasurmentDetails = (params, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.setOrderMeasurement(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`MEASURMENT.${res.message.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getDesignDetail = (id) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getOrderDesignDetail(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ORDER_DESIGN_DETAIL,
        payload: res.data.designs,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSingleDesignDetail = (devOrderId, designId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getSingleDesignDetail(devOrderId, designId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SINGLE_DESIGN_DETAIL,
        payload: res.data?.designs?.[0] || null,
      });
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};

export const ProductTesting = (data) => async (dispatch) => {
  try {
    const res = await Prodtesting.getProductTesting(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ORDER_TESTING,
        payload: res.data,
      });
      return res;
    }
    if (res) {
      toasterMsg(backendErrorMsg((key) => i18next.t(key), res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const searchTextFromTest = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SEARCH_TEXT,
      payload: data,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateForGroupby = (data) => async (dispatch) => {
  try {
    if (data) {
      await dispatch({
        type: t.UPDATE_NEW_ORDER_TESTING,
        payload: data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateProductBom = (data) => async (dispatch) => {
  try {
    if (data) {
      await dispatch({
        type: t.UPDATE_NEW_PRODUCT_BOM,
        payload: data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const bomProductTesting = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getBomForProductTesting(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_TESTING_BOM_LIST,
        payload: res.data,
      });
    } else if (res) {
      toasterMsg(backendErrorMsg((key) => i18next.t(key), res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const colourProductTesting = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getColoursForProductTesting(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_TESTING_COLOUR_LIST,
        payload: res.data,
      });
    } else if (res) {
      toasterMsg(backendErrorMsg((key) => i18next.t(key), res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchLibrarySuggestion = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllLibList(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_LIBRARY_LIST,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchGroupSuggestion = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllGroupList(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_GROUP_LIST,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductSuggestion = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllProductList(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_PRODUCT_LIST,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(transactionMsg(ERROR_MESSAGE), 'danger');
  }
};

export const getComments = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getTheComment(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_THE_COMMENTS,
        payload: res.data,
      });
    } else if (res) {
      toasterMsg(backendErrorMsg((key) => i18next.t(key), res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const forPreviewReport = (params, id) => async (dispatch) => {
  try {
    const res = await Prodtesting.getSpecificTestReport(params, id);
    if (res?.code === 200) {
      await dispatch({
        type: t.DATA_FOR_PREVIEW,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getTestingAtrribute = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllTestingAttri(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.TESTING_ATTRIBUTES,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const removeComments = (params, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.delteTheComment(params, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductListSuggestion = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllProducts(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_PRODUCTS,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchallProductRefs = () => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllProductRefs();
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_PRODUCT_REF,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchallProductRefsForBom = (data) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllProductRefsForBom(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_PRODUCT_REF_BOM,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchReportList = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllproductReports(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_REPORTS,
        payload: res.data.doc,
      });
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchTestReportList = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getTestReportProductTesting(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.TESTING_REQUIRMENTS,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getFilteredReport = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getFilteredTestReport(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.FILTERED_TESTING_REPORTS,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchArchiveReport = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getArchiveReport(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_ARCHIVE_REPORTS,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchProductBomTesting = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getAllProductTestingAttri(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.TESTING_ATTRIBUTES,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addToTest = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.addColorLibrary(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const newPostApi = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.postFromBom(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addProductTest = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.addProductTesting(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addTestToProduct = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.postTestsFromProduct(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateTestToProduct = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.putTestsFromProduct(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addToGroupTest = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.addColorGroup(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addToProductTest = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.sendTestingToProduct(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const postComment = (data, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.PostTestComment(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const approveRejectComment = (data, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.ApproveRejectComment(data, id);
    if (res?.code === 200) {
      toasterMsg('Test approved/rejected successfully', 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const postDocuments = (data, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.addTestingReports(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const uploadTestReportDocuments = (data, id, type, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.uploadingTestingReports(data, id, type);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const RenewTestReportDocuments = (data, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.RenewTestingReports(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const uploadDoc = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.UploadTestingReport(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getDocument = (params) => async (dispatch) => {
  try {
    const response = await Prodtesting.getAllTestingAttri(params);
    if (response.code === 200) {
      await dispatch({
        type: t.TESTING_ATTRIBUTES,
        payload: response.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearTestingAttribute = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.TESTING_ATTRIBUTES,
      payload: [],
    });
  } catch (err) {
    console.log(err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const sendCodetoLibrary = (data, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.sendTestingToLibrary(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(res.message);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addtoLibraryTesting = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.addProductToLibrary(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const PostFromAttri = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.PostFromAttribute(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateTestingRequirment = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.updateTestRequirmentProductTesting(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_REDUCER,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const updateTestReports = (data, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.updateTestReports(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(`${res.data.errMsg}`);
    toasterMsg(msg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveDesignAnnotation = (devOrderId, designId, imageId, data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.saveDesignAnnotation(devOrderId, designId, imageId, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleAnnotation = (orderId, sampleId, annotationType) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getOrderSamples(orderId, sampleId);
    if (res?.code === 200) {
      let payloadData;
      if (annotationType === 'sampleImages') {
        payloadData = res.data.sampleImages;
      } else if (annotationType === 'supplierAnnotation') {
        payloadData = res.data.supplierAnnotateImages;
      } else {
        payloadData = res.data.sampleAnnotateImages;
      }

      await dispatch({
        type: t.GET_ORDER_SAMPLES,
        payload: payloadData,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setAnnotedSampleImage = (orderId, sampleId, data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.setAnnotedSamples(orderId, sampleId, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteTesting = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.deleteProductTests(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`, 'success');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteTestingReport = (data, id, comId, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.delteTestReports(data, id, comId);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteTestingFromProduct = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.delteTestsFromProduct(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteTestingRequirments = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.delteTestRequirments(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const editSequence = (data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.edit_Sequence(data);
    if (res?.code === 200) {
      const msg = transactionMsg(res.message);
      toasterMsg(msg, 'success');
      return true;
    }
    const err_msg = transactionMsg(res.data.errMsg);
    toasterMsg(err_msg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateTesting = (data, id, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.editTest(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`PRODUCT_TESTING.${res.message}`, 'success');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSupplier = (pramams) => async (dispatch) => {
  try {
    const res = await Sample.getSupplier(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_SUPPLIER,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMainSamples = (pramams) => async (dispatch) => {
  try {
    const res = await Sample.getMainSamples(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_MAIN_SAMPLES,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getOrderSamples = (devOrderId, query) => async () => {
  try {
    const res = await Sample.getOrderSamples(devOrderId, query);
    if (res?.code === 200) {
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSingleSample = (obj) => async (dispatch) => {
  try {
    const res = await Sample.getSingleSample(obj);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_TRACKING_DATES_DATA,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const submitAddEditSampleForm = (data, transaction) => async () => {
  try {
    const result = await Sample.submitAddEditSampleForm(data);
    if (result?.success && result?.statusCode === HTTP_STATUS.OK) {
      const responseData = result?.data;
      if (responseData?.code === 200) {
        const msg = transaction(`DEVELOPMENT_ORDER.${responseData.message}`);
        toasterMsg(msg, 'success');

        return responseData.code;
      }
    }
    toasterMsg(transaction(result?.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const submitEditSampleForm = (data, transactionMsg) => async () => {
  try {
    const result = await Sample.submitEditSampleForm(data);

    if (result?.success && result?.statusCode === HTTP_STATUS.OK) {
      const responseData = result?.data;
      if (responseData?.code === 200) {
        const msg = transactionMsg(`DEVELOPMENT_ORDER.${responseData.message}`);
        toasterMsg(msg, 'success');
        return responseData.code;
      }
    }
    console.log('🚀 ~ submitEditSampleForm ~ result:', result);
    toasterMsg(transactionMsg(result?.data?.data?.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateSampleTrackingDates = (data, transactionMsg) => async () => {
  try {
    const result = await Sample.updateSampleTrackingDates(data);

    if (result?.success && result?.statusCode === HTTP_STATUS.OK) {
      const responseData = result?.data;
      if (responseData?.code === 200) {
        const msg = transactionMsg(`DEVELOPMENT_ORDER.${responseData.message}`);
        toasterMsg(msg, 'success');
        return responseData.code;
      }
    }
    toasterMsg(transactionMsg(result?.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const uploadCommentImg = (data) => async () => {
  try {
    const res = await DevelopmentOrder.uploadAndGetSummernoteImage(data);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteSamples = (data, transactionMsg) => async () => {
  try {
    const res = await Sample.deleteSamples(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
      toasterMsg(msg, 'success');

      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateSamplePriority = (devOrderId, sampleId, priority, transactionMsg) => async () => {
  try {
    const res = await Sample.updateSamplePriority(devOrderId, sampleId, priority);

    if (res?.data?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res?.data?.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    toasterMsg(res?.data?.errMsg ?? 'Failed to update priority', 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(error?.message ?? ERROR_MESSAGE, 'danger');
  }
};

export const submitSampleTrackingForm = (data) => async () => {
  try {
    const res = await Sample.submitSampleTrackingForm(data);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getColourWays = (data) => async (dispatch) => {
  try {
    const res = await Sample.getColourWays(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_COLOUR_WAY,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSizes = (data) => async (dispatch) => {
  try {
    const res = await Sample.getSizes(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_SIZE,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getLegLength = (data) => async (dispatch) => {
  try {
    const res = await Sample.getLegLength(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_LENGTH,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setSampleTabPermission = (params, data, val, transactionMsg) => async (dispatch) => {
  try {
    const res = await Sample.setSamplesPermission(params, data);
    if (res?.code === 200 && val !== 'switch') {
      toasterMsg('Sample comments added/updated successfully.', 'success');
    }
    if (res?.code === 200 && val === 'switch') {
      const msg = transactionMsg(`BOM_CONFIG.${res.message}`);
      toasterMsg(msg, 'success');
      await dispatch({
        type: t.UPDATE_SAMPLE_SWITCHES,
        payload: data.sampleSwitches,
      });
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleTabPermission = (data) => async (dispatch) => {
  try {
    const res = await Sample.getSamplesPermission(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_PERMISSION,
        payload: res.data?.isVisibleToSupplier || {},
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setSampleAnnotations = (params, data, transactionMsg) => async () => {
  try {
    const res = await Sample.setSamplesAnnotationsImage(params, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const replaceSampleImage = (data, transactionMsg) => async () => {
  try {
    const res = await Sample.replaceSamplesImage(data);

    if (res?.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleAnnotations = (params) => async (dispatch) => {
  try {
    const res = await Sample.getSamplesAnnotationsImage(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_ANNOTATIONS_IMAGE,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSampleAnnotations = (params, transactionMsg, tosterOnOff) => async () => {
  try {
    const res = await Sample.saveSamplesAnnotationsImage(params);
    if (res?.code === 200) {
      if (tosterOnOff !== 'tosterOff') {
        const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
        toasterMsg(msg, 'success');
      }
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteSampleAnnotations = (devOrderId, sampleId, params, transactionMsg) => async () => {
  try {
    console.log('deleteSampleAnnotations from action......');
    const res = await Sample.deleteSamplesAnnotation(devOrderId, sampleId, params);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
      toasterMsg(msg, 'success');

      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setSampleImages = (params, data, sampleId) => async () => {
  try {
    const res = await Sample.submitSampleImages(params, data, sampleId);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleImage = (sampleID) => async (dispatch) => {
  try {
    const res = await Sample.getSamplesImage(sampleID);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_IMAGE,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleDetail = (sampleId, data) => async (dispatch) => {
  try {
    const res = await Sample.getSamplesDetails(sampleId, data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_DETAILS,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleDropdownOptions = (devOrderId, sampleId) => async (dispatch) => {
  try {
    const res = await Sample.getSampleDropdownOptions(devOrderId, sampleId);
    if (res?.code === 200 && res?.data) {
      return { options: res.data.options ?? [], currentSampleHasChild: res.data.currentSampleHasChild ?? false };
    }
    return { options: [], currentSampleHasChild: false };
  } catch (error) {
    console.log(error.toString());
    return { options: [], currentSampleHasChild: false };
  }
};

export const getSampleVersionList = (devOrderId, sampleId) => async (dispatch) => {
  try {
    const res = await Sample.getSampleVersionList(devOrderId, sampleId);
    if (res?.code === 200 && Array.isArray(res?.data)) {
      return res.data;
    }
    return [];
  } catch (error) {
    console.log(error.toString());
    return [];
  }
};

export const getSampleMissingComponent = (devOrderId, data) => async (dispatch) => {
  try {
    const res = await Sample.getSamplesMissingComponent(devOrderId, data);
    if (res?.code === 200) {
      await dispatch({
        type: t.MISSING_COMPONENT,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');

    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSampleMissingComp = (params, transactionMsg, tosterOnOff) => async () => {
  try {
    const res = await Sample.submitSampleMissingComponent(params);
    if (res?.code === 200) {
      if (tosterOnOff !== 'tosterOff') {
        const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
        toasterMsg(msg, 'success');
      }
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveCommonComment = (params, transactionMsg) => async () => {
  try {
    const res = await Sample.saveCommentService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(`DEVELOPMENT_ORDER.${res.data.errMsg}`), 'danger');
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleComments = (params) => async () => {
  try {
    const res = await Sample.getSampleComments(params);
    if (res?.code === 200) {
      return res.data.doc;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const editComment = (params) => async () => {
  try {
    const res = await Sample.editComment(params);
    if (res?.code === 200) {
      return res.data.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateComment = (data, transactionMsg) => async () => {
  try {
    const res = await Sample.updateComment(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.data.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const commentReaded = (data) => async () => {
  try {
    const res = await Sample.commentReaded(data);
    if (res?.code === 200) {
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleTraking = () => async (dispatch) => {
  try {
    const res = await Sample.getSampleTraking();
    if (res?.code === 200) {
      await dispatch({
        type: t.SAMPLE_TRAKING_ARRAY,
        payload: res.data,
      });
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const storeSampleTrakingDatesAction = (data) => async (dispatch) => {
  try {
    if (data) {
      await dispatch({
        type: t.SAMPLE_TRAKING_ARRAY,
        payload: data,
      });
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const selectedIdsRecordArray = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SELECTED_IDS_ARRAY,
      payload: obj,
    });
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getSampleStatusDetails = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSampleStatus(params); // API
    await dispatch({
      type: t.GET_SAMPLE_STATUS,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unMOunt = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.DEVELOPMENT_ORDER_UNMOUNT,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unMountSampleDetails = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_SAMPLE_DETAIL,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unMountSampleSpecSize = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_SAMPLE_SPECIFICATION_SIZE,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleSpecificationDetail = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSampleSpecification(params); // API
    await dispatch({
      type: t.GET_SAMPLE_SPECIFICATION,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const saveSampleTabData = (data, params, tosterOnOff, successMessage) => async (dispatch) => {
  try {
    const res = await Sample.saveSampleTabDataService(data, params); // API
    if (res.code === 200) {
      const objs = {
        devOrderId: params.devOrderId,
      };
      dispatch(getSampleDetail(params.sampleId, objs));
      if (tosterOnOff !== 'tosterOff') {
        const rawSection = typeof params?.section === 'string' ? params.section.trim() : '';
        let message = successMessage;
        if (!message) {
          message = rawSection
            ? i18next.t('DEVELOPMENT_ORDER.SAMPLES.SECTION_UPDATED_SUCCESS', {
                ns: 'product-sample',
                section: rawSection.charAt(0).toUpperCase() + rawSection.slice(1),
              })
            : i18next.t('DEVELOPMENT_ORDER.SAMPLES.UPDATED_SUCCESS', { ns: 'product-sample' });
        }
        toasterMsg(message, 'success');
      }
    }
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleSpecificationSizeDetail = (params) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getSizeSampleSpecification(params); // API
    await dispatch({
      type: t.SAMPLE_SPECIFICATION,
      payload: res.data,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleSpecificationByGradingGroup = (params) => async (dispatch) => {
  const res = await Sample.getSampleMeasurementsByGradingGroup(params);
  if (res?.data?.code === 200) {
    await dispatch({
      type: t.SAMPLE_SPECIFICATION,
      payload: res.data.data,
    });
  } else {
    toasterMsg(res?.data?.message || ERROR_MESSAGE, 'danger');
  }
};

/**
 * Warn that the sample saved but its specification measurements were left untouched.
 *
 * The backend commits the sample rows and then skips the OrderGradingMeasurements sync
 * whenever the sample's own size differs from the specification's base size, reporting
 * the affected POMs on an otherwise successful 200. Without this toast the save looks
 * fully applied while the spec silently kept its previous measurements.
 *
 * The two save paths hand down a `t` bound to different namespaces — ProductSamples
 * binds `product-sample`, Samples binds `common` — and i18next is initialised without
 * a `fallbackNS`, so a bare key resolves in one path and renders as its own literal
 * name in the other. The namespace is therefore named on the key itself, which resolves
 * under either binding because both instances hold every namespace.
 * @param {Object} res Axios response from a sample specification save.
 * @param {Function} transactionMsg Namespaced i18next `t`.
 * @returns {void}
 */
const notifyBaseSizeMismatches = (res, transactionMsg) => {
  const baseSizeMismatches = res?.data?.data?.baseSizeMismatches || [];
  if (baseSizeMismatches.length === 0) return;

  const distinct = (key) => [...new Set(baseSizeMismatches.map((mismatch) => mismatch[key]).filter(Boolean))].join(', ');
  const message = transactionMsg(BASE_SIZE_MISMATCH_MESSAGE_KEY, {
    codes: distinct('code'),
    sampleSize: distinct('sampleSizeName'),
    specSize: distinct('specBaseSizeName'),
  });
  toasterMsg(message, 'warning', BASE_SIZE_MISMATCH_TOAST_DURATION);
};

export const saveSampleSpecification = (sampleId, params, data, transactionMsg, tosterOnOff) => async () => {
  const res = await Sample.saveSamplesSpecificationData(sampleId, params, data);
  if (res?.data?.code === 200) {
    if (tosterOnOff !== 'tosterOff') {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.data.message}`);
      toasterMsg(msg, 'success');
    }
    notifyBaseSizeMismatches(res, transactionMsg);
    return true;
  }
  toasterMsg(res?.data?.message || ERROR_MESSAGE, 'danger');
};

export const saveSampleSpecificationMulti = (sampleId, params, data, transactionMsg, tosterOnOff) => async () => {
  const res = await Sample.saveSamplesSpecificationDataMulti(sampleId, params, data);
  if (res?.data?.code === 200) {
    if (tosterOnOff !== 'tosterOff') {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.data.message}`);
      toasterMsg(msg, 'success');
    }
    notifyBaseSizeMismatches(res, transactionMsg);
    return true;
  }
  toasterMsg(res?.data?.message || ERROR_MESSAGE, 'danger');
};

export const orderSubmitAndDownload = (params) => async () => {
  try {
    console.log('orderSubmitAndDownload');
    const res = await DevelopmentOrder.orderSubmitAndDownload(params); // API
    if (res.data && res.code === 200) {
      return res;
    }
    toasterMsg(res.message, 'danger');
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const unreadCommentCount = (count) => async (dispatch) => {
  try {
    await dispatch({
      type: t.COUNT_UNREAD_COMMENTS,
      payload: count,
    });
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const saveSupplierComments = (sampleId, params, data, transactionMsg, tosterOnOff) => async () => {
  try {
    const res = await Sample.saveSupplierCommentsService(sampleId, params, data);
    if (res?.code === 200) {
      if (tosterOnOff !== 'tosterOff') {
        const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
        toasterMsg(msg, 'success');
      }
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSupplierCommentsMulti = (sampleId, params, data, transactionMsg, tosterOnOff) => async () => {
  try {
    const res = await Sample.saveSupplierCommentsServiceMulti(sampleId, params, data);
    if (res?.code === 200) {
      if (tosterOnOff !== 'tosterOff') {
        const msg = transactionMsg(`DEVELOPMENT_ORDER.${res.message}`);
        toasterMsg(msg, 'success');
      }
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addingDesignDetail = (id, data, transactionMsg) => async () => {
  try {
    data = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'addEdit',
    };
    const res = await Prodtesting.addDesignDetails(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Mark a design as default image
 * @param {string} id - Development order ID
 * @param {string} designId - Design ID to mark as default
 * @param {Function} transactionMsg - Translation function
 * @returns {Promise<boolean>} - Success status
 */
export const markDefaultDesignDetail = (id, designId, transactionMsg) => async () => {
  try {
    const res = await ProductDesigns.markDefaultDesign(id, { designId });
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'MARKED_AS_DEFAULT'}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

/**
 * Save design sequence (reorder designs)
 * @param {string} id - Development order ID
 * @param {Object} data - Data object with designs array, comments, isComplete
 * @param {Function} transactionMsg - Translation function
 * @returns {Promise<boolean>} - Success status
 */
export const saveDesignSequenceDetail = (id, data, transactionMsg) => async () => {
  try {
    const res = await ProductDesigns.saveDesignSequence(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'SEQUENCE_SAVED'}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

/**
 * Save image sequence for a design detail
 * @param {string} devOrderId - Development order ID
 * @param {string} designId - Design detail ID
 * @param {Array} images - Array of images in the new sequence order
 * @param {Function} transactionMsg - Translation function
 * @param {boolean} suppressToaster - Whether to suppress toaster messages
 * @param {boolean} isSwap - Whether this is a swap operation (for history tracking)
 * @returns {Promise<boolean>} - Success status
 */
export const saveDesignImageSequence =
  (devOrderId, designId, images, transactionMsg, suppressToaster = false, isSwap = false) =>
  async () => {
    try {
      const res = await ProductDesigns.saveDesignImageSequence(devOrderId, designId, images, isSwap);
      if (res?.code === 200) {
        if (!suppressToaster) {
          const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'IMAGE_SEQUENCE_SAVED'}`);
          toasterMsg(msg, 'success');
        }
        return true;
      }
      if (res?.data?.errMsg && !suppressToaster) {
        const msg = transactionMsg(`${res.data.errMsg}`);
        toasterMsg(msg, 'danger');
      }
      return false;
    } catch (err) {
      console.log(err.toString());
      if (!suppressToaster) {
        toasterMsg(ERROR_MESSAGE, 'danger');
      }
      return false;
    }
  };

/**
 * Create a new design
 * @param {string} id - Development order ID
 * @param {Object} data - Data object with newDesign
 * @param {Function} transactionMsg - Translation function
 * @param {boolean} suppressToaster - Whether to suppress toaster messages (default: false)
 * @returns {Promise<Object>} - Created design with _id
 */
export const createNewDesignDetail =
  (id, data, transactionMsg, suppressToaster = false) =>
  async () => {
    try {
      const res = await ProductDesigns.createNewDesign(id, data);
      if (res?.code === 200) {
        if (!suppressToaster) {
          const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'DESIGN_CREATED'}`);
          toasterMsg(msg, 'success');
        }
        return res.data;
      }
      if (res?.data?.errMsg) {
        if (!suppressToaster) {
          const msg = transactionMsg(`${res.data.errMsg}`);
          toasterMsg(msg, 'danger');
        }
      }
      return null;
    } catch (err) {
      console.log(err.toString());
      if (!suppressToaster) {
        toasterMsg(ERROR_MESSAGE, 'danger');
      }
      return null;
    }
  };

/**
 * Save image to a specific design detail slot
 * @param {string} devOrderId - Development order ID
 * @param {string} designId - Design detail ID
 * @param {Object} data - Data object with imageIndex, s3Key, imageTitle, imageDescription
 * @param {Function} transactionMsg - Translation function
 * @param {boolean} suppressToaster - Whether to suppress toaster messages (for auto-save)
 * @returns {Promise<boolean>} - Success status
 */
export const saveDesignImageDetail =
  (devOrderId, designId, data, transactionMsg, suppressToaster = false) =>
  async () => {
    try {
      const res = await ProductDesigns.saveDesignImage(devOrderId, designId, data);
      if (res?.code === 200) {
        if (!suppressToaster) {
          const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'IMAGE_SAVED'}`);
          toasterMsg(msg, 'success');
        }
        return true;
      }
      if (res?.data?.errMsg && !suppressToaster) {
        const msg = transactionMsg(`${res.data.errMsg}`);
        toasterMsg(msg, 'danger');
      }
      return false;
    } catch (err) {
      console.log(err.toString());
      if (!suppressToaster) {
        toasterMsg(ERROR_MESSAGE, 'danger');
      }
      return false;
    }
  };

/**
 * Save comment for design details
 * @param {string} devOrderId - Development order ID
 * @param {Object} data - Data object with comments
 * @param {Function} transactionMsg - Translation function
 * @param {boolean} suppressToaster - Whether to suppress success toaster message (for auto-save)
 * @returns {Promise<boolean>} - Success status
 */
export const saveDesignCommentDetail =
  (devOrderId, data, transactionMsg, suppressToaster = false) =>
  async () => {
    try {
      const res = await ProductDesigns.saveDesignComment(devOrderId, data);
      if (res?.code === 200) {
        if (!suppressToaster) {
          const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'COMMENT_SAVED'}`);
          toasterMsg(msg, 'success');
        }
        return true;
      }
      if (res?.data?.errMsg) {
        if (!suppressToaster) {
          const msg = transactionMsg(`${res.data.errMsg}`);
          toasterMsg(msg, 'danger');
        }
      }
      return false;
    } catch (err) {
      console.log(err.toString());
      if (!suppressToaster) {
        toasterMsg(ERROR_MESSAGE, 'danger');
      }
      return false;
    }
  };

/**
 * Save the per-design PDF-excluded rich-text comment and surgically update
 * the affected design row in the store, avoiding a full design-list refetch.
 * @param {string} devOrderId - Development order ID
 * @param {string} designId - Design ID
 * @param {Object} data - { comment } HTML payload
 * @param {Function} transactionMsg - Translation function
 * @param {boolean} suppressToaster - Suppress success toaster (auto-save default)
 * @returns {Promise<boolean>} - Success status
 */
export const saveDesignPdfExcludedCommentDetail =
  (devOrderId, designId, data, transactionMsg, suppressToaster = false) =>
  async (dispatch) => {
    try {
      const res = await ProductDesigns.saveDesignPdfExcludedComment(devOrderId, designId, data);
      if (res?.code === 200) {
        dispatch({
          type: t.UPDATE_DESIGN_PDF_EXCLUDED_COMMENT,
          payload: {
            designId,
            pdfExcludedComment: res?.data?.comment ?? data?.comment ?? '',
          },
        });
        if (!suppressToaster) {
          const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'COMMENT_SAVED'}`);
          toasterMsg(msg, 'success');
        }
        return true;
      }
      if (res?.data?.errMsg && !suppressToaster) {
        const msg = transactionMsg(`${res.data.errMsg}`);
        toasterMsg(msg, 'danger');
      }
      return false;
    } catch (err) {
      console.log(err.toString());
      if (!suppressToaster) {
        toasterMsg(ERROR_MESSAGE, 'danger');
      }
      return false;
    }
  };

export const postPermissionInDesignDetails = (id, data, transactionMsg) => async () => {
  try {
    const res = await Prodtesting.postPermissionForDesignDetails(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const markAsComplete = (id, data, transactionMsg) => async () => {
  try {
    data = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'addEdit',
    };
    const res = await Prodtesting.markCompletion(id, data);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteDesignDetails = (devOrderId, data, transactionMsg) => async () => {
  try {
    const res = await ProductDesigns.deleteDesignDetail(devOrderId, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data?.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const deleteMultipleDesignDetails = (devOrderId, data, transactionMsg) => async () => {
  try {
    const res = await ProductDesigns.deleteMultipleDesignDetails(devOrderId, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data?.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const deleteDesignImage = (devOrderId, designId, imageId, transactionMsg) => async () => {
  try {
    const res = await ProductDesigns.deleteDesignImage(devOrderId, designId, imageId);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data?.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const replaceDesignDetails = (data, transactionMsg) => async () => {
  try {
    data = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'addEdit',
    };
    const res = await Prodtesting.replaceSamples(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return res.data;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Crop default design image
 * @param {string} devOrderId - Development order ID
 * @param {string} designId - Design ID
 * @param {string} croppedImageS3Key - S3 key of cropped image
 * @param {Function} transactionMsg - Translation function
 * @returns {Promise<boolean>} - Success status
 */
export const cropDefaultDesignDetails = (devOrderId, designId, croppedImageS3Key, transactionMsg) => async () => {
  try {
    const res = await ProductDesigns.cropDefaultDesign(devOrderId, {
      _id: designId,
      croppedImage: croppedImageS3Key,
    });
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'CROPPED_IMAGE_SAVED'}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const duplicateDesignDetails = (data, transactionMsg) => async () => {
  try {
    data = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'addEdit',
    };
    const res = await Prodtesting.duplicateSamples(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const archDesignDetails = (data, transactionMsg) => async () => {
  try {
    const params = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'addEdit',
    };
    const res = await Prodtesting.archiveSample(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unArchDesignDetails = (data, transactionMsg) => async () => {
  try {
    data = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'addEdit',
    };
    const res = await ProductDesigns.unArchiveDesignDetail(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const appRojDesignDetails = (data, transactionMsg) => async () => {
  try {
    data = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'approveReject',
    };
    const res = await Prodtesting.appRejSample(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const removeDesignStatus = (data, transactionMsg) => async () => {
  try {
    data = {
      ...data,
      section: 'products',
      module: 'design',
      action: 'approveReject',
    };
    const res = await Prodtesting.removeSampleDesign(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
      toasterMsg(msg, 'success');
    } else if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getDesignDetails = (id) => async (dispatch) => {
  const params = { section: 'products', module: 'design' };
  try {
    const res = await Prodtesting.fetchDesignDetails(id, params);
    if (res?.code === 200) {
      await dispatch({
        type: t.ALL_DESIGN_DETAILS,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPermissionInDesignDetails = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.fetchDesignDetailsPermission(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.DESIGN_DETAILS_PERMISSION,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getAllDocumentList = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getDocumentList(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.ALL_DOCUMENT_OPTION_LIST,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getManualAndDocs = (params) => async (dispatch) => {
  try {
    const res = await Prodtesting.getmanualDocList(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.ALL_DOCUMENT_OPTION_LIST,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearDocOptions = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.ALL_DOCUMENT_OPTION_LIST,
      payload: [],
    });
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const resetModal = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.RESET_MODAL,
    });
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSampleSpecificationData = (sampleId, data) => async (dispatch) => {
  try {
    const res = await Sample.getSamplesDetails(sampleId, data);
    if (res?.code === 200) {
      if (res.data?.measurementData) {
        await dispatch({
          type: t.GET_SAMPLES,
          payload: res.data,
        });
      }
      return res.data?.measurementData ? res.data : [];
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearSampleTypeGroupsByProduct = () => (dispatch) => {
  dispatch({ type: t.CLEAR_SAMPLE_TYPE_GROUPS_BY_PRODUCT });
};

export const getSampleTypeGroupsByProduct = (params) => {
  return async (dispatch) => {
    try {
      const result = await SystemMasterServices.getSampleTypeGroupsByProduct(params);
      if (result.success && result.statusCode === HTTP_STATUS.OK) {
        const responseData = result.data;
        if (responseData?.code === 200) {
          await dispatch({
            type: t.GET_SAMPLE_TYPE_GROUPS_BY_PRODUCT,
            payload: responseData.data,
          });
          return responseData.data;
        }
      }
      if (!result.success) {
        const body =
          typeof result.data === 'string'
            ? (() => {
                try {
                  return JSON.parse(result.data);
                } catch {
                  return {};
                }
              })()
            : result.data ?? {};
        const errMsg = body?.data?.errMsg ?? body?.message;
        let msg = errMsg ?? 'Something went wrong. Please try again.';
        if (result.statusCode === HTTP_STATUS.NOT_FOUND) msg = 'Sample type groups not found';
        else if (result.statusCode === HTTP_STATUS.BAD_REQUEST) msg = errMsg ?? 'Bad request';
        toasterMsg(msg, 'danger');
      }
      return [];
    } catch (error) {
      console.log(error.toString());
      toasterMsg(error.message || 'Failed to fetch sample type groups', 'danger');
      return [];
    }
  };
};

export const setSampleSpecificationData = (sampleSpecifications) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SAMPLE_SPECIFICATION,
      payload: sampleSpecifications,
    });
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMeasurmentProduct = (id) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getMeasurmentProductDetail(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.MEASUREMENT_PRODUCT,
        payload: res.data,
      });
      return res.data;
    }
    return null;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductGrading = (gradingId, params, getType) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductGradingDetail(gradingId, params);
    if (res?.code === 200) {
      await dispatch({
        type: getType === 'search' ? t.SPEC_SEARCH : t.PRODUCT_GRADING,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getMeasurmentData = (id, clear) => async (dispatch) => {
  try {
    if (clear) {
      await dispatch({
        type: t.MEASUREMENT_DATA,
        payload: [],
      });
      return;
    }
    const res = await DevelopmentOrder.getMeasurmentData(id);
    if (res?.code === 200) {
      await dispatch({
        type: t.MEASUREMENT_DATA,
        payload: res.data,
      });
      return res?.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getMeasurementPermission = (data) => async () => {
  try {
    const res = await SupplierSuggestionService.getMeasurementPermissionByID(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const saveMeasurementPermission = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.saveMeasurementPermission(data);
    if (res.code === 200) {
      toasterMsg(transactionMsg('Orders Permission updated successfully '), 'success');

      return res.data;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveMeasurmentDetails = (params, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.saveOrderMeasurements(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.data.toString()), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(transactionMsg(ERROR_MESSAGE), 'danger');
  }
};

/**
 * Carries the specPomAllCodes a spec save just persisted into the loaded grading group document.
 *
 * The save writes a fresh list every time but returned it to no one, so the store kept the copy it
 * loaded with. After deleting a POM its code therefore remained in the store's list and the import
 * guards refused to re-add it, until an explicit Save refetched the group and cleared it — the
 * delete itself had always persisted correctly (BM-9510).
 * @param {Array<string>} specPomAllCodes - the code list that was just written.
 * @returns {Function} thunk.
 */
export const syncSpecPomAllCodes = (specPomAllCodes) => (dispatch) => {
  dispatch({ type: t.SPEC_POM_ALL_CODES, payload: specPomAllCodes });
};

export const saveGradGroupMeasurments = (params) => async () => {
  try {
    const res = await DevelopmentOrder.saveGradGroupMeasurments(params);
    if (res.code === 200) {
      return res?.data || true;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err?.response?.data?.message || ERROR_MESSAGE, 'danger');
  }
  return false;
};

export const getCADFile = (devId, params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getCADFileDetail(devId, params);
    if (res?.code === 200) {
      await dispatch({
        type: t.CAD_DATA,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCADSpecificationFile = (cadId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getCADSpecFileDetail(cadId);
    if (res?.code === 200) {
      await dispatch({
        type: t.CAD_SPEC_DATA,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearCADSearch = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_CAD_SEARCH,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addSpecFileToLibrary = (params, msg) => async () => {
  try {
    const res = await DevelopmentOrder.addSpecFileToLibrary(params, msg);
    const showMsg = msg(`MEASUREMENT.${res.message}`);
    toasterMsg(showMsg, 'success');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setMarkComplete = (devId, params, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.markComplete(devId, params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    } else {
      toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchCadFromProduct = (devId, gradingGroupId) => async () => {
  try {
    return await DevelopmentOrder.fetchCadFromProduct(devId, gradingGroupId);
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchCadFilesFromProduct = (data) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.fetchCadFilesFromProduct(data);
    if (res?.code === 200) {
      if (data.type === 'pattern') {
        await dispatch({
          type: t.CAD_SPEC_DATA,
          payload: res.data,
        });
      } else return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setHideShowGrading = (id, payload, msg) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.setGrading(id, payload);
    if (res?.code === 200) {
      const showMsg = msg(`MEASUREMENT.${res.message}`);
      toasterMsg(showMsg, 'success');
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getUnitData = (params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.fetchUnit(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.UNITS,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Adds a Specification row's image to the POM library. The server answers a rejected push with a
 * real HTTP status, so its reason arrives on the rejection and is shown translated.
 * @param {string} devId - Product the row belongs to.
 * @param {Object} data - The Specification row, carrying its code, image and imageKey.
 * @param {Function} msg - Translator for the common namespace.
 * @returns {Function} thunk.
 */
export const uploadImageToLibrary = (devId, data, msg) => async () => {
  try {
    const res = await DevelopmentOrder.addImageToLibrary(devId, data);
    if (res?.code === 200) {
      toasterMsg(msg(`MEASUREMENT.${res.message}`), 'success');
    }
  } catch (err) {
    toasterMsg(backendErrorMsg(msg, `MEASUREMENT.${getApiErrorKey(err)}`), 'danger');
  }
};

export const addCadFile = (devId, data) => async () => {
  console.log('data', data, 'devId', devId);
  try {
    const res = await DevelopmentOrder.addCadFile(devId, data);
    if (res.data.errMsg) {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    } else {
      toasterMsg(res.message, 'success');
    }
    if (res?.code === 200) return res?.data;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearHighlightMeasurement = (devId, params) => async () => {
  try {
    const res = await DevelopmentOrder.clearMeasurement(devId, params);
    if (res?.code === 200) {
      toasterMsg('Measurement highlight cleared successfully.', 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const importXlFile = (data) => async () => {
  try {
    return await DevelopmentOrder.importXlFile(data);
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Uploads a Specification workbook to the server-side importer. The server owns parsing, merging,
 * grade-rule derivation, persistence and Product History; this thunk only carries the payload and
 * reports the shared failure envelope this app uses in place of 401/403.
 * @param {string} devOrderId Development order whose spec is being imported into.
 * @param {FormData} data Multipart body carrying `xls` and `gradingGroupId`.
 * @returns {Promise<object|undefined>} The response envelope, or undefined when the call failed.
 */
export const importSpecificationXlFile = (devOrderId, data) => async () => {
  try {
    const res = await DevelopmentOrder.importSpecificationXlFile(devOrderId, data);
    if (res?.data?.errMsg) {
      toasterMsg(res.data.errMsg.toString(), 'danger');
      return undefined;
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return undefined;
  }
};

export const getOtherDocuments = (id) => async () => {
  try {
    return await DevelopmentOrder.getOtherDocuments(id);
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPomDocuments = (id) => async () => {
  try {
    return await DevelopmentOrder.getPomDocuments(id);
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteDocuments = (data) => async () => {
  try {
    const res = await DevelopmentOrder.deleteDocuments(data);
    if (res.data.errMsg) {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    } else {
      toasterMsg(res.message, 'success');
    }

    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateDocuments = (data) => async () => {
  try {
    const res = await DevelopmentOrder.updateDocuments(data);
    if (res.data.errMsg) {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    } else {
      toasterMsg(res.message, 'success');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getPermission = (params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getcompletionDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.MAEK_AS_COMPLETE,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addPermissions = (id, paramData, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.postPermissions(id, paramData);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const markAsCompleteProducts = (data, t) => async () => {
  try {
    const res = await DevelopmentOrder.markAsComplete(data);
    if (res?.code === 200) {
      toasterMsg(res.message, 'success');
      return res; // Return the successful response
    }
    const msg = t(`${res?.data?.errMsg || 'COMMON.ERROR_MESSAGE'}`);
    toasterMsg(msg, 'danger');
    return false; // Return false for failed response
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false; // Return false for caught errors
  }
};

export const getPermission1 = (params) => async () => {
  try {
    const res = await DevelopmentOrder.getcompletionDetails1(params);
    if (res?.code === 200) {
      return res;
    }
    // The Axios interceptor resolves with undefined once it has handled a session
    // timeout or a 401 itself; it has already toasted and is redirecting, so a
    // second toast here would contradict it.
    if (res) {
      toasterMsg(backendErrorMsg((key) => i18next.t(key), res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const getOrderTestingReqReport = (params) => async () => {
  try {
    const response = await DevelopmentOrder.getOrderTestingReqReport(params);
    if (response.code === 200) {
      return response.data;
    }
    toasterMsg(response.message, 'danger');
  } catch (err) {
    console.log(err);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSpecFile = (devId, params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getSpecFileDetail(devId, params);
    if (res?.code === 200) {
      console.log('resres', res.data);
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSpecFilePom = (params) => async () => {
  try {
    const res = await DevelopmentOrder.getSpecFilePoms(params);
    if (res.code === 200) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSampleImageSetsSequence = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.saveSampleImageSetsSequence(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSampleImagesSequence = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.saveSampleImagesSequence(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateSampleImages = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.updateSampleImages(params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getEcommSpec = (key) => async () => {
  try {
    const res = await DevelopmentOrder.getEcommSpecAccess(key);
    if (res?.code === 200) {
      return res?.data[0];
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addProduct = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.insertDevOrder(withStringCustomType(data));
    if (res.code === 200) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
    if (res.data) {
      toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    const errorKey = getApiErrorKey(err);
    toasterMsg(backendErrorMsg(transactionMsg, errorKey), 'danger');
  }
};

export const updateProduct = (id, data, transactionMsg) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.updateDevOrder(id, withStringCustomType(data));

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      /*
       * The update returns the saved product in LIST shape, so the row is patched straight into
       * the loaded list. That keeps the table's scroll position and paging intact — refetching
       * page one instead reset both, and left the pages in between unloaded.
       *
       * Safe for every caller: rows whose id is not on the loaded page are ignored by the
       * reducer, so a screen that does not show this product is unaffected.
       */
      if (res.data?._id) {
        dispatch({ type: t.DEVORDER_PRODUCT_LIST_PATCH, payload: [res.data] });
      }
      return res.code;
    }
    if (res.data) {
      toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    const errorKey = getApiErrorKey(err);
    toasterMsg(backendErrorMsg(transactionMsg, errorKey), 'danger');
  }
};

/**
 * Save several products in one request (BM-9596 bulk inline edit).
 *
 * Returns the whole `data` envelope rather than a status code, because the endpoint reports
 * per-item outcomes: the caller closes the rows in `succeeded` and keeps the rows in `failed`
 * open with their edits and their own message. Returns null only when the request itself failed.
 * @param {Array<object>} products one payload per dirty row, each carrying its devOrderId
 * @param {Function} transactionMsg i18n translate fn
 * @returns {Promise<object|null>} { totalRequested, successCount, failureCount, succeeded, failed }
 */
export const bulkUpdateProducts = (products, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.bulkUpdateDevOrders({ products });

    if (res.code === 200 && res.data) {
      return res.data;
    }
    if (res.data) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return null;
  } catch (err) {
    console.log(err.toString());
    /* Whole-request rejections (400 over-cap / bad envelope) carry the reason in the error body;
       anything else is a genuine transport failure and falls back to the generic message. */
    const errMsg = err?.response?.data?.data?.errMsg;
    toasterMsg(errMsg ? transactionMsg(errMsg) : ERROR_MESSAGE, 'danger');
    return null;
  }
};

export const duplicateProduct = (id, data, reOrderFlag, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.duplicateDevOrder(id, data, reOrderFlag);
    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
    if (res.data) {
      toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    const errorKey = getApiErrorKey(err);
    toasterMsg(backendErrorMsg(transactionMsg, errorKey), 'danger');
  }
};

export const getOtherProductTags = () => async () => {
  try {
    const res = await DevelopmentOrder.getProductTags();
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductEditRules = (id) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getDevOrderEditRules(id);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.PRODUCT_EDIT_RULE,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Re-read specific products in LIST shape and patch them into the loaded list.
 *
 * Saving used to trigger a full list refetch, which reset paging, re-applied every filter and
 * sort server-side, and threw away the user's scroll position — to update rows already on screen.
 * This asks the same list endpoint for just the saved ids, so the rows come back in exactly the
 * shape every consumer already expects (reference fields as display names, not populated objects,
 * which is what the card view renders directly).
 *
 * Returns false when the rows could not be read, so the caller can fall back to a full refresh
 * rather than leave stale values on screen. That includes the case where the server returns fewer
 * rows than were asked for: an edit can move a product OUT of the active filter or search, and the
 * row then has to leave the list entirely — which patching in place cannot express.
 * @param {string[]} devOrderIds ids of the products to re-read
 * @param {object} listParams the current list query (filters, sort, archived/deleted flags)
 * @returns {Promise<boolean>} true when the list was patched
 */
export const patchDevOrderRowsByIds = (devOrderIds, listParams = {}) => async (dispatch) => {
  const ids = (Array.isArray(devOrderIds) ? devOrderIds : []).map(String).filter(Boolean);
  if (!ids.length) return false;
  try {
    const res = await DevelopmentOrder.getDevOrder({ ...listParams, count: 0, devOrderIds: ids });
    const rows = res?.data?.doc;
    if (res?.code !== 200 || !Array.isArray(rows) || rows.length !== ids.length) return false;
    dispatch({
      type: t.DEVORDER_PRODUCT_LIST_PATCH,
      payload: rows,
    });
    return true;
  } catch (err) {
    console.log('Error: DevelopmentOrder.action: patchDevOrderRowsByIds:-', err);
    return false;
  }
};

export const getDevelopmentOrder = (param) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getDevOrder(param);
    if (res.code === 200 && res.data) {
      dispatch({
        type: t.PRODUCT_LIST_DEVORDER,
        payload: res.data,
      });
      dispatch({
        type: t.DEVORDER_PRODUCT_LIST,
        payload: { ...param, data: res?.data?.doc, totalCount: res?.data?.count },
      });
      return true;
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Re-read specific products through the LIST endpoint and patch them into the loaded list.
 *
 * Used after a save so the rows on screen show the new values without refetching the page. The
 * list endpoint is used (not the edit-detail one) because it returns reference fields as display
 * NAMES; a detail-shaped row stored here would break the card view that shares this list.
 *
 * `devOrderIds` narrows the read to just those products, so this never re-runs paging — the
 * response carries only the saved rows, and the reducer replaces them in place.
 * @param {string[]} devOrderIds ids of the products to re-read
 * @param {Object} listParams the caller's current archived/deleted context
 * @returns {Promise<boolean>} true when the rows were patched
 */
/**
 * Patch already-fetched product rows into the loaded list.
 *
 * Used after a bulk save, which returns the saved rows in list shape — patching from that response
 * avoids a second list request that can come back empty and silently leave the grid stale.
 * @param {Array} rows product rows in list shape
 * @returns {Function} thunk that dispatches the patch when there is anything to patch
 */
export const patchProductRows = (rows) => (dispatch) => {
  if (!Array.isArray(rows) || !rows.length) return false;
  dispatch({ type: t.DEVORDER_PRODUCT_LIST_PATCH, payload: rows });
  return true;
};

export const patchProductsInList = (devOrderIds, listParams = {}) => async (dispatch) => {
  const ids = (Array.isArray(devOrderIds) ? devOrderIds : []).map(String).filter(Boolean);
  if (!ids.length) return false;
  try {
    const res = await DevelopmentOrder.getDevOrder({ ...listParams, devOrderIds: ids, count: 0 });
    const rows = res?.code === 200 ? res?.data?.doc : null;
    if (!Array.isArray(rows) || !rows.length) return false;
    dispatch({ type: t.DEVORDER_PRODUCT_LIST_PATCH, payload: rows });
    return true;
  } catch (err) {
    /* The save already succeeded; a failed re-read only leaves the row showing its previous
       values, so it must not surface as a save error. */
    return false;
  }
};

/**
 * Loads a product for the edit / duplicate screen.
 *
 * Resolves to the response only when a product actually came back. A non-200 used to return
 * `undefined` silently, which the screen could not tell apart from a successful load and which
 * left it rendering an empty but editable form over a product it had never read.
 * @param {string} id Dev order id.
 * @returns {Promise<Object|undefined>} The response, or `undefined` when nothing was loaded.
 */
export const getEditedProductDetail = (id) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getDevOrderById(id);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.PRODUCT_EDIT_DATA,
        payload: res.data,
      });
      return res;
    }
    toasterMsg(res?.message || ERROR_MESSAGE, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return undefined;
};

export const archivedProduct = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.setArchivedProduct(data);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
    if (res.code === 400 && res.data) {
      toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
    }
    if (res.code === 500 && res.data) {
      toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const trashProduct = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.setTrashProduct(data);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteProductData = (id, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.deleteProduct(id);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateProductGroup = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.setProductGroup(data);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateProductStatus = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.setProductStatus(data);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductCompletion = (id, data) => async () => {
  try {
    const res = await DevelopmentOrder.getCompletionDetail(id, data);

    if (res.code === 200 && res.data) {
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addProductGroup = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.addProductGroupData(data);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addProductToGroup = (data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.addProductToGroupData(data);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getAdminUser = () => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getAdminUserDetail();
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.ADMIN_USER,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCompanyUser = (data) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getCompanyUserDetail(data);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.COMPANY_USER,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSupplierForSubmitPopup = (pramams) => async () => {
  try {
    const res = await Sample.getSupplier(pramams);
    if (res?.code === 200) {
      const setList = (arr) => {
        const arrs = cloneDeep(arr);
        return arrs.map((val) => {
          return { ...val, value: val.name, label: val.name };
        });
      };
      return setList(res.data);
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const getProductReorderDetail = (data) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductReorder(data);
    if (res.code === 200 && res.data) {
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unlinkDevOrder = (id, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.unlinkReorderProduct(id);

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PRODUCTS.${res.message}`);
      toasterMsg(msg, 'success');
      return res.code;
    }
    toasterMsg(backendErrorMsg(transactionMsg, res?.data?.errMsg), 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getReorderList = (data) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductReorderList(data);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.REORDER_LIST,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
  return null;
};
export const bulkSubmitDownload = (data) => async () => {
  try {
    const res = await DevelopmentOrder.bulkSubmitDownload(data);
    if (res.code === 200 && res.data) {
      toasterMsg(res.message, 'success');
    } else if (res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger', 5000);
    }
    return res.code;
  } catch (err) {
    toasterMsg(backendErrorMsg((key) => i18next.t(key), getApiErrorKey(err)), 'danger');
  }
};

export const productChangeGrading = (id, deselectedGrading) => async () => {
  try {
    const res = await DevelopmentOrder.changeGrading(id, deselectedGrading);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const isSameSupplierExist = (params) => async () => {
  try {
    return await DevelopmentOrder.checkIsSameSupplierExist(params);
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSubmitHistory = (data) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getSubmitHistory(data);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.GET_MULTI_SUBMIT_LIST,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const unmountComponent = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_LIST,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unmountProductModal = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_PRODUCT_MODAL,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSupplierImagesSequence = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.saveSupplierImagesSequence(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const unmountDesignDetail = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.UNMOUNT_DESIGN_DETAILS,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const replaceSupplierImage = (data, transactionMsg) => async () => {
  try {
    const res = await Sample.replaceSupplierImage(data);

    if (res?.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateSupplierImages = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.updateSupplierImages(params);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const addUpdatePomsToSpec = (params, transactionMsg) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.addUpdatePomsToSpec(params, transactionMsg);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
      return res;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearHighlightTesting = (data, t) => async () => {
  try {
    const res = await Prodtesting.clearHighlight(data);
    if (res?.code === 200) {
      toasterMsg(t(res.data), 'success');
      return res;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

/**
 * Loads one page of a grading group's specification into the store.
 *
 * Rows are read back without the client-only `temp_` id and `rowId` render key older saves stored.
 * A row still carrying a `temp_` id is treated as never saved — autosave skips it and its typed
 * values are overwritten — so normalising here, at the one entry every load goes through, repairs
 * those documents without a migration (BM-10142).
 * @param {object} params devOrderId, gradingGroupId, pomPage, pomLimit, isScrolled and allData
 * @returns {Function} thunk resolving to the loaded document, or undefined on failure
 */
export const getSelectedGradGroupData = (params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getSelectedGradGroupData(params);

    if (res.code === 200 && res.data) {
      const specPomLibraries = withoutClientKeys(res.data.specPomLibraries);
      const loadedData = specPomLibraries === res.data.specPomLibraries ? res.data : { ...res.data, specPomLibraries };
      await dispatch({
        type: t.PRODUCT_GRADING_MEASUREMENTS,
        payload: loadedData,
        isScrolled: params.isScrolled || false,
      });
      return loadedData;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const fetchAllProducts = () => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getAllProducts();
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_OPEN_PRODUCTS,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const checkIfProductMeasurementsExists = async (params) => {
  try {
    const res = await DevelopmentOrder.checkIfProductMeasurementsExists(params);
    if (res?.code === 200) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSamplePaginationWise = (devOrderId, query) => {
  return async () => {
    try {
      const result = await Sample.getSamplePaginationWiseService(devOrderId, query);
      if (result?.success && result?.statusCode === HTTP_STATUS.OK) {
        const responseData = result?.data;
        if (responseData?.code === 200) {
          return responseData;
        }
      }
      if (!result.success) {
        const body =
          typeof result.data === 'string'
            ? (() => {
                try {
                  return JSON.parse(result.data);
                } catch {
                  return {};
                }
              })()
            : result.data ?? {};
        const errMsg = body?.data?.errMsg ?? body?.message;
        let msg = errMsg ?? 'Something went wrong. Please try again.';
        if (result.statusCode === HTTP_STATUS.NOT_FOUND) msg = 'Samples not found';
        else if (result.statusCode === HTTP_STATUS.BAD_REQUEST) msg = errMsg ?? 'Bad request';
        toasterMsg(msg, 'danger');
      }
      return [];
    } catch (error) {
      console.log(error.toString());
      toasterMsg(ERROR_MESSAGE, 'danger');
    }
  };
};

export const clearProductGrading = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_PRODUCT_GRADING,
    });
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const clearCadSpecData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_CAD_SPEC,
    });
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const exportExcel = (params) => async () => {
  try {
    const { blob } = await Sample.exportExcelService(params);
    const filename = `${params?.productNumber} -  ${params.code} - Sample Specification - ${moment().format('DD-MM-YYYY')}.xlsx`;
    fileSaver.saveAs(blob, filename);
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearSampleSpecificationReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_SPECIFICATION_REDUCER,
    });
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const savePermission = (params, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.savePermission(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res?.message}`);
      toasterMsg(msg, 'success');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCustomModuleList = (params) => async (dispatch) => {
  try {
    await dispatch({
      type: t.CUSTOM_MODULE_MENU_LOADING_STATE,
      payload: true,
    });
    const res = await DevelopmentOrder.getCustomModule(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.CUSTOM_MODULE_MENU,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSystemCanvasModuleMenu = (params) => async (dispatch) => {
  try {
    const { devOrderId } = params;
    if (!devOrderId) {
      return [];
    }
    const res = await getAvailableModulesForDevOrder(devOrderId);
    if (res?.code === 200) {
      await dispatch({
        type: t.SYSTEM_CANVAS_MODULE_MENU,
        payload: res?.data?.modules || [],
      });
      return res?.data?.modules || [];
    }
    return [];
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return [];
  }
};

export const getLibraryCardMenu = (params) => async (dispatch) => {
  try {
    const { devOrderId } = params;
    if (!devOrderId) return [];
    const res = await listControlLibrariesForProduct(devOrderId);
    const libraries = res?.data || [];
    await dispatch({
      type: t.LIBRARY_CARD_MENU,
      payload: libraries,
    });
    return libraries;
  } catch (err) {
    return [];
  }
};

export const saveProductCustomModule = (params, transactionMsg) => async () => {
  try {
    const dataString = JSON.stringify(params);
    let chunkSuccessful = null;
    chunkSuccessful = await DevelopmentOrder.saveCustomModule({ data: dataString }, params.customModuleId);
    if (chunkSuccessful?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${chunkSuccessful?.message}`);
      toasterMsg(msg, 'success');
    } else {
      const msg = chunkSuccessful.data?.errMsg;
      toasterMsg(transactionMsg(msg.toString()), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCustomModuleById = (devId, libId, pageId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductCustomModuleId(devId, libId, pageId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_CM_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const UNMOUNT_CUSTOM_LIBRARY = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_CUSTOM_LIB_DATA,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getModulePermission = (params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductCustomModulePermission(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.CUSTOM_MODULE_PERMISSION_DATA,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateProductCustomModule = (params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getUpdatedCustomModule(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_CM_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const setModulePermission = (params, payload, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.setProductCustomModulePermission(params, payload);
    if (res?.code === 200) {
      const msg = transactionMsg(`DEVELOPMENT_ORDER.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    const msg = transactionMsg(res.data?.errMsg);
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addToBOMLibrary = (id, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.addToBomLibrary(id);
    if (res?.code === 200) {
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getSupportingDesignDetails = (id, params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getSupportingDesignDetails(id, params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_DESIGN_SUPPORTING_DOC,
        payload: res.data,
      });
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSupportingDesignDetails = (id, data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.saveSupportingDesignDetails(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res?.message), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const updateSupportingDesignDetails = (id, data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.updateSupportingDesignDetails(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res?.message), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

const buildSupportingDocKey = (devOrderId, sanitizedName, file) => {
  const fileExtension = file.name.split('.').pop().toLowerCase();
  const safeName = sanitizedName.replace(/ +/g, '');
  const uniquePrefix = generateUniqueFilePrefix();
  return `${getSlugName()}/development-order/${devOrderId}/designs/supporting_documents/${uniquePrefix}_${safeName}.${fileExtension}`;
};

export const uploadSupportingDesignDetailInBackground =
  (devOrderId, file, saveData, transactionMsg, onComplete) => async (dispatch) => {
    const persistMetadata = async (objectKey) => {
      const payload = {
        ...saveData,
        s3Key: objectKey,
        documentSize: formatFileSize(file.size),
        originalFileExtension: file.name.split('.').pop().toLowerCase(),
      };
      const res = saveData.editId
        ? await DevelopmentOrder.updateSupportingDesignDetails(devOrderId, payload)
        : await DevelopmentOrder.saveSupportingDesignDetails(devOrderId, payload);
      if (res?.code === 200) {
        return { ok: true, message: `DESIGN_DETAILS.${res?.message}` };
      }
      return { ok: false, message: res?.data?.errMsg || res?.message || 'modules/design-detail:DOCUMENT_UPLOAD_FAILED' };
    };

    return dispatch(
      runBackgroundUpload(dispatch, {
        file,
        buildObjectKey: (uploadFile) => buildSupportingDocKey(devOrderId, saveData.documentName, uploadFile),
        persistMetadata,
        onSuccess: onComplete,
        pendingMeta: {
          module: 'design-supporting-doc',
          devOrderId,
          fileName: file.name,
          addToDesign: Boolean(saveData.addToDesign),
          isAddToAssetLibrary: Boolean(saveData.isAddToAssetLibrary),
          isVisibleToSupplier: Boolean(saveData.isVisibleToSupplier),
          documentType: saveData.documentType || null,
          expiredOn: saveData.expiredOn || null,
        },
        onSuccessMessage: (message) => toasterMsg(transactionMsg(message), 'success'),
        onFailedMessage: (message) => toasterMsg(transactionMsg(message || 'modules/design-detail:DOCUMENT_UPLOAD_FAILED'), 'danger'),
        onCancelledMessage: () => toasterMsg(transactionMsg('modules/design-detail:DOCUMENT_UPLOAD_CANCELLED'), 'warning'),
      }),
    );
  };

/**
 * Pushes resumable-upload records into the floating uploader widget as
 * 'resumable' rows. Each row carries module + devOrderId so the widget can route
 * Resume/Discard to the correct module handler.
 * @param {Function} dispatch - Redux dispatch.
 * @param {Array} records - Resumable-upload records from the API.
 */
const pushResumableRows = (dispatch, records) => {
  records.forEach((record) => {
    dispatch({
      type: uploaderType.ADD_FILES_IN_QUEUE_UPLOADER,
      payload: {
        [record.taskId]: {
          taskId: record.taskId,
          fileName: record.fileName,
          fileSize: record.fileSize,
          devOrderId: record.devOrderId,
          productNumber: record.productNumber,
          module: record.module,
          addToDesign: record.addToDesign,
          isAddToAssetLibrary: record.isAddToAssetLibrary,
          isVisibleToSupplier: record.isVisibleToSupplier,
          documentType: record.documentType,
          expiredOn: record.expiredOn,
          percentage: 0,
          completed: false,
          cancellable: false,
          status: 'resumable',
        },
      },
    });
  });
};

/**
 * Fetches resumable (unfinished) supporting-doc uploads for a dev order and
 * pushes them into the floating uploader widget. Called when the user returns to
 * the Design Detail supporting-doc page. Scoped server-side to the logged-in user.
 */
export const fetchResumableUploads = (devOrderId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getResumableSupportingUploads(devOrderId);
    const resumable = res?.code === 200 && Array.isArray(res.data) ? res.data : [];
    pushResumableRows(dispatch, resumable);
    return resumable;
  } catch (err) {
    console.log(err.toString());
    return [];
  }
};

/**
 * Fetches ALL of the logged-in user's resumable uploads (every dev order and
 * module) and pushes them into the floating widget. Backs the global (any-page)
 * resume prompt after relogin/crash. Scoped server-side to the logged-in user.
 */
export const fetchAllResumableUploads = () => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getAllResumableUploads();
    const resumable = res?.code === 200 && Array.isArray(res.data) ? res.data : [];
    const notLiveElsewhere = resumable.filter((record) => !isLiveInAnotherTab(record.taskId));
    pushResumableRows(dispatch, notLiveElsewhere);
    return notLiveElsewhere;
  } catch (err) {
    console.log(err.toString());
    return [];
  }
};

/**
 * Resumes a previously-started supporting-doc upload. Verifies the re-picked file
 * matches the pending record by name + size, fetches the resume state (uploadId +
 * already-uploaded parts) and continues the upload, skipping stored parts. On a
 * mismatch the resumable row is kept so the user can retry with the correct file.
 */
export const resumeSupportingUpload =
  (resumableRecord, repickedFile, transactionMsg, onComplete) => async (dispatch) => {
    if (resumableRecord.module && resumableRecord.module !== 'design-supporting-doc') {
      return false;
    }
    if (repickedFile.name !== resumableRecord.fileName || repickedFile.size !== resumableRecord.fileSize) {
      toasterMsg(transactionMsg('modules/design-detail:RESUME_FILE_MISMATCH'), 'danger');
      return false;
    }

    const devOrderId = resumableRecord.devOrderId;
    const stateRes = await DevelopmentOrder.getSupportingUploadResumeState(devOrderId, resumableRecord.taskId);
    if (stateRes?.code !== 200 || !stateRes.data?.uploadId) {
      toasterMsg(transactionMsg('modules/design-detail:RESUME_EXPIRED'), 'danger');
      dispatch({ type: uploaderType.REMOVE_TASK_FROM_LIST, payload: resumableRecord.taskId });
      return false;
    }
    const { uploadId, objectKey, partSize, partCount, uploadedPartNumbers } = stateRes.data;

    const saveData = {
      documentName: resumableRecord.fileName.split('.').slice(0, -1).join('.') || resumableRecord.fileName,
      isVisibleToSupplier: resumableRecord.isVisibleToSupplier,
      addToDesign: resumableRecord.addToDesign,
      isAddToAssetLibrary: resumableRecord.isAddToAssetLibrary,
      documentType: resumableRecord.documentType,
      expiredOn: resumableRecord.expiredOn,
    };

    const persistMetadata = async (savedObjectKey) => {
      const payload = {
        ...saveData,
        s3Key: savedObjectKey,
        documentSize: formatFileSize(repickedFile.size),
        originalFileExtension: repickedFile.name.split('.').pop().toLowerCase(),
      };
      const res = await DevelopmentOrder.saveSupportingDesignDetails(devOrderId, payload);
      if (res?.code === 200) {
        return { ok: true, message: `DESIGN_DETAILS.${res?.message}` };
      }
      return { ok: false, message: res?.data?.errMsg || res?.message || 'modules/design-detail:DOCUMENT_UPLOAD_FAILED' };
    };

    return dispatch(
      runBackgroundUpload(dispatch, {
        file: repickedFile,
        buildObjectKey: () => objectKey,
        persistMetadata,
        onSuccess: onComplete,
        completionScope: { module: 'design-supporting-doc', devOrderId },
        resume: {
          taskId: resumableRecord.taskId,
          objectKey,
          state: { uploadId, partSize, partCount, uploadedPartNumbers },
        },
        onSuccessMessage: (message) => toasterMsg(transactionMsg(message), 'success'),
        onFailedMessage: (message) => toasterMsg(transactionMsg(message || 'modules/design-detail:DOCUMENT_UPLOAD_FAILED'), 'danger'),
        onCancelledMessage: () => toasterMsg(transactionMsg('modules/design-detail:DOCUMENT_UPLOAD_CANCELLED'), 'warning'),
      }),
    );
  };

/**
 * Discards a resumable upload: aborts the S3 multipart upload, clears the pending
 * record server-side, and removes the row from the floating widget.
 */
export const discardResumableUpload = (devOrderId, taskId) => async (dispatch) => {
  try {
    await DevelopmentOrder.discardResumableSupportingUpload(devOrderId, taskId);
  } catch (err) {
    console.log(err.toString());
  } finally {
    dispatch({ type: uploaderType.REMOVE_TASK_FROM_LIST, payload: taskId });
  }
};

export const deleteDesignDetailsSupprtingDoc = (id, data, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.deleteSupportingDesignDetails(id, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res?.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    if (res?.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(transactionMsg(res?.message), 'danger');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearMeasurementDataReducer = () => async (dispatch) => {
  try {
    dispatch({
      type: t.CLEAR_MEASUREMENT_GRADING_DATA,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearProductGradingMeasurements = () => (dispatch) => {
  dispatch({
    type: t.PRODUCT_GRADING_MEASUREMENTS,
    payload: null,
  });
};

export const getDescriptionevelopmentOrder = (param) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getDescDevOrder(param);
    if (res.code === 200 && res.data) {
      dispatch({
        type: t.PRODUCT_LIST_MATCH,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearDescriptionSearch = () => async (dispatch) => {
  try {
    dispatch({
      type: t.CLEAR_PRODUCT_LIST_MATCH,
    });
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getProductIdentifier = (param) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductIdentifier(param);
    if (res.code === 200 && res.data) {
      dispatch({
        type: t.GET_PRODUCT_IDENTIFIER_LIST,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveProductIdentifier = (id, data, t, fromDeleted) => async () => {
  try {
    const res = await DevelopmentOrder.saveProductIdentifier(id, data);
    if (res.code === 200 && res.data) {
      if (!fromDeleted) {
        toasterMsg(t(`PRODUCT_IDENTIFIER.${res.message}`), 'success');
      }
      return true;
    }
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearProductIdentifierReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_IDENTIFIER_REDUCER,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const saveProductPages = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: t.PRODUCST_PAGES,
      payload: data,
    });
  } catch (err) {
    console.log('............', err);
  }
};

export const deleteS3ImageOfPage = (data) => async () => {
  try {
    const res = await DevelopmentOrder.deleteCMPageImages(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getProductCMPageList = (devId, libId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductCustomModulePages(devId, libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_CM_PAGES,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deletePageFromProductCM = (data) => async () => {
  try {
    const res = await DevelopmentOrder.deleteProdctCMPage(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const copyPageinProductCM = (data) => async () => {
  try {
    const res = await DevelopmentOrder.updateCopiedPageInLibrary(data);
    if (res?.code === 200) {
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getProductCMPageDependentList = (devId, libId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getProductCustomModuleDepednent(devId, libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_CM_DEPENDENT_LISTS,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getProductCMContentPage = (devId, libId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getContentPageData(devId, libId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_CM_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchProductname = (devId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.fetchProductname(devId);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PRODUCT_NAME,
        payload: res?.data,
      });
      return res;
    }
    const msg = res.data?.errMsg;
    toasterMsg(msg.toString(), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const checkDamExist = (devId) => async () => {
  try {
    const res = await DevelopmentOrder.checkDamExist(devId);
    if (res?.code === 200) {
      return res.data;
    }
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteProductAllDam = (devId) => async () => {
  try {
    const res = await DevelopmentOrder.deleteProductAllDam(devId);
    if (res?.code === 200) {
      toasterMsg('Product dam removed successfully', 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

// refresh by pages
export const updateProductCustomModuleByPages = (params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getUpdatedCustomModuleByPages(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_PRODUCT_CM_BY_ID,
        payload: res?.data,
      });
      return res;
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getdppModuleList = (params) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getDppModule(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.DPP_MODULE_MENU,
        payload: res.data,
      });
    }
    return res.data;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

// ## action to download the excel sheet from the Testing Attributes.
export const downloadTestingAttribute = (data, translation) => async () => {
  try {
    const res = await DevelopmentOrder.exportTestingUsageDetails(data);
    if (res) {
      if (data?.isProduct) {
        fileSaver.saveAs(res, `${data?.testCode}-BOM Library Testing Usage`);
      } else {
        fileSaver.saveAs(res, `${data?.testCode}-BOM Product Testing Usage`);
      }
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(translation(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(translation(res?.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

// ## action to download the excel sheet from the Testing Attributes.
export const downloadProductTestingAttribute = (data, translation) => async () => {
  try {
    const res = await DevelopmentOrder.exportProductTestingUsageDetails(data);
    if (res) {
      if (data?.isProduct) {
        fileSaver.saveAs(res, `${data?.testCode}-BOM Library Testing Usage`);
      } else {
        fileSaver.saveAs(res, `${data?.testCode}-BOM Product Testing Usage`);
      }
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(translation(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(translation(res?.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const getCounterValueNumber = (brandId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.setCounterValueNumber(brandId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_ALL_COUNT_OPTIONS,
        payload: res.data,
      });
    }
    return res.data;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const checkBomExitInProduct = (devId) => async () => {
  try {
    const res = await DevelopmentOrder.checkBomExitInProduct(devId);
    if (res?.code === 200) {
      return res.data;
    }
    return false;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteProductAllBom = (devId) => async () => {
  try {
    const res = await DevelopmentOrder.deleteProductAllBom(devId);
    if (res?.code === 200) {
      toasterMsg('Product bom removed successfully', 'success');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getBomDetailsBasedOnId = (devId, bomId, bomTypeId) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getBomDetailsBasedOnId(devId, bomId, bomTypeId);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_BOM_DETAILS_BY_ID,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveSampleAnnoationsSequence = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.saveSampleAnnoationsSequence(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSupplierAnnoationsSequence = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.saveSupplierAnnoationsSequence(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const saveSupplierImageSetSequence = async (params, transactionMsg) => {
  try {
    const res = await DevelopmentOrder.saveSupplierImageSetSequence(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearBomEditModalData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_BOM_EDIT_ADD,
    });
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const deleteComment = (params, transactionMsg) => async () => {
  try {
    const res = await DevelopmentOrder.deleteSampleComment(params);
    if (res.code === 200) {
      toasterMsg(transactionMsg(res.message), 'success');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err.toString(), 'danger');
  }
};
export const getSuggestionProductDetail = (id) => async (dispatch) => {
  try {
    const res = await DevelopmentOrder.getSuggestionDevOrderId(id);
    if (res.code === 200 && res.data) {
      await dispatch({
        type: t.PRODUCT_EDIT_DATA,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const productChangeFactory = (params) => async () => {
  try {
    const res = await DevelopmentOrder.changeFactory(params);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
export const addingSingleDesignTitle =
  (id, data, transactionMsg, suppressToaster = false) =>
  async () => {
    const startTime = performance.now();
    try {
      const res = await Prodtesting.addSingleDesignDetails(id, data);
      const duration = performance.now() - startTime;

      // Log performance if exceeds target
      if (duration > 500) {
        console.warn(`Auto-save took ${duration}ms (target: <500ms)`);
      }

      if (res?.code === 200) {
        if (!suppressToaster) {
          const msg = transactionMsg(`DESIGN_DETAILS.${res.message}`);
          toasterMsg(msg, 'success');
        }
        return { success: true, data: res.data };
      }
      if (res?.data?.errMsg) {
        const error = new Error(res.data.errMsg);
        if (!suppressToaster) {
          const msg = transactionMsg(`${res.data.errMsg}`);
          toasterMsg(msg, 'danger');
        }
        throw error;
      }
      return { success: false, error: 'Unknown error' };
    } catch (err) {
      const duration = performance.now() - startTime;
      console.error(`Auto-save failed after ${duration}ms:`, err.toString());
      if (!suppressToaster) {
        toasterMsg(ERROR_MESSAGE, 'danger');
      }
      throw err; // Re-throw so component can handle it
    }
  };

/**
 * Upload design detail image to S3
 * @param {File} file - Image file to upload
 * @param {string} devOrderId - Development order ID
 * @param {number} designIndex - Design index (0-based)
 * @param {number} imageIndex - Image index within design (0-based)
 * @param {Function} onProgress - Progress callback (optional)
 * @returns {Promise<{success: boolean, s3Key: string, presignedUrl: string}>} - Upload result with S3 key and presigned URL
 */
export const uploadDesignImageToS3 = (file, devOrderId, designIndex, imageIndex, onProgress) => async () => {
  try {
    const result = await ProductDesigns.uploadDesignImageToS3(file, devOrderId, designIndex, imageIndex, onProgress);
    return {
      success: true,
      s3Key: result.s3Key,
      presignedUrl: result.presignedUrl,
    };
  } catch (error) {
    console.error('Failed to upload design image to S3:', error);
    toasterMsg(ERROR_MESSAGE, 'danger');
    throw error;
  }
};

export const getUserSuppliers = () => async () => {
  try {
    const res = await SupplierSuggestionService.getUserSuppliers();
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getTypeBasedCatgeoryDetails = (data) => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getTypeBasedCatgeory(data);
    if (res.code === 200) {
      await dispatch({
        type: t.FETCH_TYPE_BASED_CATEGORY,
        payload: { data: res.data, categoryType: data.categoryType },
      });
    }
    return res;
  } catch (error) {
    console.log(error.message);
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const replaceDesignImage = (devOrderId, designId, imageId, file, transactionMsg) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append('image', file);

    const res = await DevelopmentOrder.replaceDesignImage(devOrderId, designId, imageId, formData);
    if (res?.code === 200) {
      const msg = transactionMsg(`DESIGN_DETAILS.${res.message || 'IMAGE_REPLACED_SUCCESSFULLY'}`);
      toasterMsg(msg, 'success');
      await dispatch(getDesignDetails(devOrderId));
      return true;
    }
    if (res?.data?.errMsg) {
      const msg = transactionMsg(`${res.data.errMsg}`);
      toasterMsg(msg, 'danger');
    }
    return false;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
    return false;
  }
};

export const importPomToSampleSpec = (params, transactionMsg) => async (dispatch) => {
  const res = await Sample.importPomToSampleSpec(params);
  if (res?.success) {
    dispatch({ type: t.SAMPLE_SPECIFICATION, payload: res.data?.data });
    toasterMsg(transactionMsg('DEVELOPMENT_ORDER.BACKEND_SERVICE.POM_IMPORTED'), 'success');
    return res;
  }
  toasterMsg(res.data?.data?.errMsg || res.data?.message || ERROR_MESSAGE, 'danger');
};

export const addManualPomToSampleSpec = (params, transactionMsg) => async (dispatch) => {
  const res = await Sample.addManualPomToSampleSpec(params);
  if (res?.success) {
    dispatch({ type: t.SAMPLE_SPECIFICATION, payload: res.data?.data });
    toasterMsg(transactionMsg('DEVELOPMENT_ORDER.BACKEND_SERVICE.POM_ADDED'), 'success');
    return res;
  }
  toasterMsg(res.data?.data?.errMsg || res.data?.message || ERROR_MESSAGE, 'danger');
};

export const deletePomFromSampleSpec = (params, transactionMsg) => async (dispatch) => {
  const res = await Sample.deletePomFromSampleSpec(params);
  if (res?.success) {
    dispatch({ type: t.SAMPLE_SPECIFICATION, payload: res.data?.data });
    toasterMsg(transactionMsg('DEVELOPMENT_ORDER.BACKEND_SERVICE.POM_DELETED'), 'success');
    return res;
  }
  toasterMsg(res.data?.data?.errMsg || res.data?.message || ERROR_MESSAGE, 'danger');
};

export const reorderSampleSpecPomSequence = (params, transactionMsg) => async () => {
  const res = await Sample.reorderSpecPomSequence(params);
  if (res?.success) {
    toasterMsg(transactionMsg('DEVELOPMENT_ORDER.BACKEND_SERVICE.POM_SEQUENCE_UPDATED'), 'success');
  } else {
    toasterMsg(res.data?.data?.errMsg || res.data?.message || ERROR_MESSAGE, 'danger');
  }
  return res;
};

export const getProductDependentData = (devId) => async () => {
  try {
    const res = await DevelopmentOrder.getProductDependentData(devId);
    if (res?.code === 200 && res.data) {
      return res.data;
    }
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return null;
  }
};

/**
 * Read several products in edit-detail shape with one request, for the table's inline edit. Unlike
 * getEditedProductDetail it never writes PRODUCT_EDIT_DATA: the table keeps its own rows, and that
 * slice belongs to the single-product pages.
 * @param {string[]} ids product ids to read
 * @returns {Promise<{rows: object[], failed: object[]}|undefined>} the details and per-item failures
 */
export const getEditedProductDetails = (ids) => async () => {
  try {
    const res = await DevelopmentOrder.getDevOrdersByIds(ids);
    if (res?.code === 200 && res.data) return res.data;
    toasterMsg(ERROR_MESSAGE, 'danger');
    return undefined;
  } catch {
    toasterMsg(ERROR_MESSAGE, 'danger');
    return undefined;
  }
};

/**
 * Copy of a product save payload whose `customType` is the custom type id string, or null. The
 * product detail carries `customType` as a lookup array (`[]`, or `[{ _id, name }]` once set),
 * which the forms would otherwise send straight back to a String field.
 * @param {Object} data - Product payload built by a product form or the table view.
 * @returns {Object} The payload, with `customType` normalised when it is present.
 */
function withStringCustomType(data) {
  if (!data || typeof data !== 'object' || !Object.prototype.hasOwnProperty.call(data, 'customType')) {
    return data;
  }
  const first = Array.isArray(data.customType) ? data.customType[0] : data.customType;
  const id = first && typeof first === 'object' ? first._id : first;
  return { ...data, customType: typeof id === 'string' && id !== '' ? id : null };
}

/**
 * Create several products in one request (BM-9594 multi-add in the table view).
 *
 * Returns the whole `data` envelope, as bulkUpdateProducts does: the endpoint reports per-row
 * outcomes keyed by the client's draft id, so the caller closes the created drafts and keeps the
 * rejected ones open with their message. A 422 means no row was created but still carries that
 * per-row body, so it is returned the same way. Returns null only when the request itself failed.
 * The endpoint's keys live in the product-information namespace, with the caller's namespace as fallback.
 * @param {Array<object>} products one create payload per draft row, each carrying its clientRowId
 * @param {Function} transactionMsg i18n translate fn
 * @returns {Promise<object|null>} { totalRequested, successCount, failureCount, succeeded, failed }
 */
export const bulkCreateProducts = (products, transactionMsg) => async () => {
  const translateKey = (key) => transactionMsg([`product-information:${key}`, key]);
  try {
    const res = await DevelopmentOrder.bulkCreateDevOrders({ products: products.map(withStringCustomType) });
    if (res.code === 200 && res.data) {
      return res.data;
    }
    toasterMsg(res?.data?.errMsg ? backendErrorMsg(translateKey, res.data.errMsg) : ERROR_MESSAGE, 'danger');
    return null;
  } catch (err) {
    const body = err?.response?.data;
    if (err?.response?.status === 422 && Array.isArray(body?.data?.failed)) {
      return body.data;
    }
    const errMsg = body?.message || body?.data?.errMsg;
    toasterMsg(errMsg ? backendErrorMsg(translateKey, errMsg) : ERROR_MESSAGE, 'danger');
    return null;
  }
};
